import DrillxPopin from 'components/DrillxPopin';
import { getWellboreLabel } from 'helpers/WellHelper';
import { memo } from 'react';
import { useIntl } from 'react-intl';
import { DataConsistencyDTO } from 'types/dataConsistency';
import { WellboreDataIntermittenceDTO } from 'types/dataIntermittenceDto';
import { MnemonicsMappingAndLiveStatusDTO } from 'types/mnemonicsMapping';
import { WellboreOutlierDTO } from 'types/outlierDto';
import { InnerSensorWellboreWithWellInfo } from 'types/wellbore';

import styles from './WellboreDataQualityPopin.module.scss';
import DetailedWellboreDataQuality from './components/DetailedWellboreDataQuality';
import WellLiveDataQualityIndicator, {
  DataQualityIndicatorColor,
} from '../WellLiveDataQualityIndicator';

export interface Props {
  open: boolean;
  onClose: () => void;
  locationType?: string;
  isFlowInBstNA: boolean;
  isFlowOutAVNA?: boolean;
  isFlowOutPCNA?: boolean;
  outlier?: WellboreOutlierDTO;
  wellboreDataQualityIndex: number;
  dataConsistency?: DataConsistencyDTO;
  wellbore: InnerSensorWellboreWithWellInfo;
  dataIntermittence?: WellboreDataIntermittenceDTO;
  mnemonicsMapping?: MnemonicsMappingAndLiveStatusDTO;
  wellboreDataQualityColor: DataQualityIndicatorColor;
}

const WellboreDataQualityPopin = ({
  open,
  onClose,
  outlier,
  wellbore,
  locationType,
  isFlowInBstNA,
  isFlowOutAVNA,
  isFlowOutPCNA,
  dataConsistency,
  mnemonicsMapping,
  dataIntermittence,
  wellboreDataQualityIndex,
  wellboreDataQualityColor,
}: Props) => {
  const intl = useIntl();

  return (
    <DrillxPopin
      {...{ open, onClose }}
      maxWidth="lg"
      className={styles.popin}
      ariaLabelledby={intl.formatMessage({ id: 'favouriteWellsPopin.ariaLabelledby' })}
    >
      <div className={styles.wellboreInfoContainer}>
        <div>
          <p className={styles.wellBoreName}>{getWellboreLabel(wellbore)}</p>
          <h1 className={styles.title}>
            {intl.formatMessage({ id: 'wellboreDataQualityPopin.title' })}
          </h1>
        </div>
        <div className={styles.dataQualityIndex}>
          <WellLiveDataQualityIndicator
            label={wellboreDataQualityIndex}
            color={wellboreDataQualityColor}
          />
        </div>
      </div>
      <DetailedWellboreDataQuality
        mnemonicsMapping={mnemonicsMapping}
        dataIntermittence={dataIntermittence}
        outlier={outlier}
        isFlowInBstNA={isFlowInBstNA}
        isFlowOutAVNA={isFlowOutAVNA}
        isFlowOutPCNA={isFlowOutPCNA}
        dataConsistency={dataConsistency}
        locationType={locationType}
      />
    </DrillxPopin>
  );
};

export default memo(WellboreDataQualityPopin);
